import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-total-week",
  "use": "icon-total-week-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-total-week\">\n<path d=\"M11.9,11.4v6.2c0,0.4-0.3,0.7-0.7,0.7H8.8c-0.4,0-0.7-0.3-0.7-0.7v-6.2c0-0.4,0.3-0.7,0.7-0.7h2.4\n\tC11.6,10.8,11.9,11,11.9,11.4z M16.5,7.7H14c-0.4,0-0.7,0.3-0.7,0.7v9.2c0,0.4,0.3,0.7,0.7,0.7h2.4c0.4,0,0.7-0.3,0.7-0.7V8.4\n\tC17.2,8,16.9,7.7,16.5,7.7z M6,13H3.5c-0.4,0-0.7,0.3-0.7,0.7v4c0,0.4,0.3,0.7,0.7,0.7H6c0.4,0,0.7-0.3,0.7-0.7v-4\n\tC6.6,13.3,6.3,13,6,13z M17.1,1.9c0,0,0-0.1-0.1-0.1l0,0c-0.1-0.1-0.2-0.1-0.3-0.1h-2.3c-0.2,0-0.4,0.2-0.4,0.4\n\tc0,0.2,0.2,0.4,0.4,0.4h1.4l-4.4,4.4l-2-2C9.4,4.7,9.1,4.7,9,4.8c0,0,0,0,0,0l-6,6c-0.1,0.1-0.1,0.4,0,0.5s0.4,0.1,0.5,0l5.8-5.8\n\tl2,2c0.1,0.1,0.4,0.1,0.5,0c0,0,0,0,0,0L16.4,3v1.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4V2.1C17.2,2,17.1,2,17.1,1.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/total-week.svg
// module id = csmh
// module chunks = 97